import { createStore } from "vuex";

import trail from "./trail";
import auth from "./auth";
import user from "./user";
import theme from "./theme";
import point from "./point";
import natural from "./natural";
import province from "./province";
import post from "./post";
import pointType from "./pointType";
import experienceType from "./experienceType";
import experience from "./experience";
import reserve from "./reserves"
import topic from "./topics";
import trailType from "./trailType";

const store = createStore({
  modules: {
    auth,
    natural,
    province,
    trail,
    point,
    user,
    theme,
    post,
    pointType,
    experience,
    experienceType,
    reserve,
    topic,
    trailType
  }
});

store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  sessionStorage.setItem('store', JSON.stringify(state.auth));
});

export default store;
